'use client';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { RouterLink } from 'src/routes/components';
import { KOM_IGÅNG, type Väg } from '../landning-innehåll';

export function KomIgång() {
    return (
        <Container
            component="section"
            id="kom-igang"
            aria-labelledby="kom-igang-rubrik"
            maxWidth="lg"
            sx={{ py: { xs: 8, md: 12 }, scrollMarginTop: 64 }}
        >
            <Typography id="kom-igang-rubrik" variant="h2" sx={{ fontSize: { xs: '1.875rem', md: '2.5rem' } }}>
                {KOM_IGÅNG.rubrik}
            </Typography>
            <Typography sx={{ mt: 1.5, maxWidth: 640, color: 'text.secondary', fontSize: { md: '1.0625rem' } }}>
                {KOM_IGÅNG.ingress}
            </Typography>

            <Box
                component="ul"
                sx={{
                    listStyle: 'none',
                    m: 0,
                    p: 0,
                    mt: { xs: 4, md: 5 },
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))' },
                    gap: 3
                }}
            >
                {KOM_IGÅNG.vägar.map((v) => (
                    <li key={v.id}>
                        <Vägkort väg={v} />
                    </li>
                ))}
            </Box>
        </Container>
    );
}

function Vägkort({ väg }: { väg: Väg }) {
    return (
        <Card
            component="article"
            aria-labelledby={`vag-${väg.id}`}
            sx={{ height: '100%', p: { xs: 3, md: 4 }, display: 'flex', flexDirection: 'column' }}
        >
            <Typography id={`vag-${väg.id}`} variant="h5" component="h3">
                {väg.titel}
            </Typography>
            <Typography variant="body2" sx={{ mt: 0.5, color: 'text.secondary' }}>
                {väg.beskrivning}
            </Typography>

            <Box component="ol" sx={{ listStyle: 'none', m: 0, p: 0, mt: 3, mb: 4, flex: 1, display: 'grid', gap: 2 }}>
                {väg.steg.map((steg, i) => (
                    <Box component="li" key={steg} sx={{ display: 'grid', gridTemplateColumns: '28px 1fr', gap: 1.5 }}>
                        <Box
                            aria-hidden
                            sx={{
                                width: 28,
                                height: 28,
                                borderRadius: '50%',
                                display: 'grid',
                                placeItems: 'center',
                                typography: 'caption',
                                fontWeight: 700,
                                color: 'primary.main',
                                bgcolor: 'primary.lighter'
                            }}
                        >
                            {i + 1}
                        </Box>
                        <Typography variant="body2" sx={{ pt: '4px' }}>
                            {steg}
                        </Typography>
                    </Box>
                ))}
            </Box>

            <Box>
                <Button component={RouterLink} href={väg.knapp.href} variant="contained" color="inherit">
                    {väg.knapp.text}
                </Button>
            </Box>
        </Card>
    );
}
